// extracted by mini-css-extract-plugin
module.exports = {"dialog--background":"dialog--background__OYzWL"};